import {
  getLeoUuid,
  LeoUUID,
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { OptOutReason } from "./optOutReason";
/* eslint-disable import/export */
export abstract class OptOutOfCampaignRPC implements
  LeoRPC<OptOutOfCampaignRPC.Request, OptOutOfCampaignRPC.Response, OptOutOfCampaignRPC.Errors.Errors>
{
  abstract execute(
    request: OptOutOfCampaignRPC.Request
  ): Promise<LeoRPCResult<OptOutOfCampaignRPC.Response, OptOutOfCampaignRPC.Errors.Errors>>;
}

export namespace OptOutOfCampaignRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    emailId: string;
    reason: OptOutReason.OptOutReasonDTO;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isOptOutOfCampaignRPCRequest: boolean = true;
  
    readonly emailId: LeoUUID;
    readonly reason: OptOutReason.OptOutReason;
  
  
    constructor(
    emailId: LeoUUID, 
    reason: OptOutReason.OptOutReason
    ) {
      this.emailId = emailId;
      this.reason = reason;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const emailId = getLeoUuid(dto, "emailId", InvalidRequestEmailIdError);
      const reason = OptOutReason.fromDTO(getObject(dto, "reason", InvalidRequestReasonError));
      return new Request(
        emailId,
        reason
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          emailId: this.emailId.toDTO(),
          reason: this.reason.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `OptOutOfCampaignRPC(emailId='${this.emailId}',reason='${this.reason}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `OptOutOfCampaignRPC.Response()`;
  };

  export enum RPCError {
    InvalidEmailId = "INVALID_EMAIL_ID"
  }

  export namespace Errors {
    
    export interface InvalidEmailIdDTO {
      code: string;
    }
    
    export class InvalidEmailId extends LeoRPCError<RPCError> {
      readonly isInvalidEmailId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidEmailId;
        super(code);
      }
    
    
      toDTO(): InvalidEmailIdDTO {
        const dto: InvalidEmailIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidEmailId.prototype.toString = function toString(): string {
      return `OptOutOfCampaignRPC.INVALID_EMAIL_ID()`;
    };
    

    export type Errors = InvalidEmailId;
    export type ErrorsDTO = InvalidEmailIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidEmailId:
          return new InvalidEmailId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestEmailIdError extends OptOutOfCampaignRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestEmailIdError";
  }
}

export class InvalidRequestReasonError extends OptOutOfCampaignRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestReasonError";
  }
}


export class InvalidResponseInvalidEmailIdError extends OptOutOfCampaignRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidEmailIdError";
  }
}

